import { render, staticRenderFns } from "./majordomo-item.vue?vue&type=template&id=9c9c4ff8&scoped=true&"
import script from "./majordomo-item.vue?vue&type=script&lang=js&"
export * from "./majordomo-item.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=9c9c4ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9c4ff8",
  null
  
)

export default component.exports